import styled from 'styled-components';

const TabularNumbers = styled.div({
  fontVariantNumeric: 'tabular-nums',
});

export { TabularNumbers };
